var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDshb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 7,
    width: 4,
    height: 19,
    fill: "#109615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 14,
    y: 6,
    width: 4,
    height: 13,
    fill: "#109615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    y: 10,
    width: 4,
    height: 9,
    fill: "#109615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDshb);
export default __webpack_public_path__ + "static/media/dshb.c9279e16fbf772d248c58561ec99379d.svg";
export { ForwardRef as ReactComponent };